import { Component, OnInit } from '@angular/core';
import {
  DialogService,
  EventAggregator,
  SearchConfig,
  tr,
  Types,
  ViewType,
  KeyBase,
  DialogResult,
  OverviewMain,
} from '@kpd/framework-ngx';
import { Tenant } from 'app/shared/models/tenant';
import { RoleFacade } from 'app/shared/services/facades/role.facade';
import { TenantService } from 'app/shared/services/tenant.service';
import { catchError, switchMap } from 'rxjs/operators';
import { RolesNavigatorHelper } from 'app/roles/roles-navigator-helper';
import { of } from 'rxjs';
import { Permissions } from 'app/shared/services/permissions';

@Component({
  selector: 'app-roles',
  templateUrl: './roles-overview.component.html',
})
export class RolesOverviewComponent extends OverviewMain implements OnInit {
  Permissions: typeof Permissions = Permissions;
  columnsConfig = this.createColumnsConfig();
  searchConfig = this.createSearchConfig();
  viewType = ViewType.Table;
  ViewTypes = ViewType;
  selectedItemIds: KeyBase[] = [];
  tenant: Tenant = new Tenant();

  constructor(
    public navigatorHelper: RolesNavigatorHelper,
    public entityFacade: RoleFacade,
    public eventAggregator: EventAggregator,
    private dialogService: DialogService,
    private tenantService: TenantService,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.tenantService.getTenant().subscribe((tenant: Tenant) => {
      this.tenant = tenant;
    });

    this.entityFacade.viewType$.subscribe(result => {
      this.viewType = result;
    });
  }

  onToggleViewType(): void {
    this.entityFacade.changeViewType(this.viewType === ViewType.Table ? ViewType.Card : ViewType.Table);
  }

  onAdd(): void {
    this.entityFacade.clearSelection();
    this.navigatorHelper.navigateToCreateFromDetail(true);
  }

  onDelete(): void {
    const message = tr('Are you sure to delete one (or more) selected roles?');
    this.dialogService
      .open('confirm', {
        message,
        header: tr('Delete role(s)'),
        verifyButtonText: tr('Delete'),
        verifyButtonStyle: 'danger',
        cancelButtonText: tr('Cancel'),
      })
      .afterClosed()
      .pipe(
        switchMap(result => {
          if (result === DialogResult.Verify) {
            return this.entityFacade.deleteItems(this.selectedItemIds);
          }
          return of({});
        }),
        catchError((error: any) => {
          if (error.status === 409 || error.status === 400) {
            return this.dialogService
              .open('conflict', {
                message: tr(`Cannot delete role due to conflict(s)`),
                header: tr('Delete failed'),
                severity: 'danger',
              })
              .afterClosed();
          }
          throw error;
        }),
      )
      .subscribe(() => {});
  }

  createColumnsConfig(): any[] {
    return [
      { field: 'name', header: tr('Name'), width: '30%', type: 'link' },
      { field: 'application', header: tr('Application'), width: '70%' },
    ];
  }

  createSearchConfig(): SearchConfig {
    return new SearchConfig({
      multipleCriteria: true,
      fields: [
        { field: 'name', displayValue: tr('Name'), dataType: Types.String },
        { field: 'application', displayValue: tr('Application'), dataType: Types.String },
      ],
    });
  }
}
